import { STRING_getInstance3lkmlozu5h7cs as STRING_getInstance } from '../descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptorkwnwsc78b2on as PrimitiveSerialDescriptor } from './Primitives.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Instant2s2zyzgfc4947 as Instant,
  Companion_getInstancec1c8yhxwuclv as Companion_getInstance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Instant.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { NothingSerialDescriptor_getInstance2zwo7fzw0h0j as NothingSerialDescriptor_getInstance } from './NothingSerialDescriptor.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../SerializationExceptions.mjs';
import {
  Duration__toIsoString_impl_9h6wsm1wi5fkopntj8m as Duration__toIsoString_impl_9h6wsm,
  Duration5ynfiptaqcrg as Duration,
  Companion_getInstancevdtg3uvqmv7f as Companion_getInstance_0,
} from '../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import {
  Uuid1zxgztb7abqxx as Uuid,
  Companion_getInstance1bxbth0yni76u as Companion_getInstance_1,
} from '../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var InstantSerializerClass;
function InstantSerializer() {
  if (InstantSerializerClass === VOID) {
    class $ {
      constructor() {
        InstantSerializer_instance = this;
        this.e1t_1 = new (PrimitiveSerialDescriptor())('kotlin.time.Instant', STRING_getInstance());
      }
      m1m() {
        return this.e1t_1;
      }
      f1t(encoder, value) {
        encoder.i1s(value.toString());
      }
      n1m(encoder, value) {
        return this.f1t(encoder, value instanceof Instant() ? value : THROW_CCE());
      }
      o1m(decoder) {
        return Companion_getInstance().nr(decoder.y1q());
      }
    }
    initMetadataForObject($, 'InstantSerializer', VOID, VOID, [KSerializer()]);
    InstantSerializerClass = $;
  }
  return InstantSerializerClass;
}
var InstantSerializer_instance;
function InstantSerializer_getInstance() {
  if (InstantSerializer_instance === VOID)
    new (InstantSerializer())();
  return InstantSerializer_instance;
}
var NothingSerializerClass;
function NothingSerializer() {
  if (NothingSerializerClass === VOID) {
    class $ {
      constructor() {
        NothingSerializer_instance = this;
        this.g1t_1 = NothingSerialDescriptor_getInstance();
      }
      m1m() {
        return this.g1t_1;
      }
      h1t(encoder, value) {
        throw SerializationException().h1o("'kotlin.Nothing' cannot be serialized");
      }
      n1m(encoder, value) {
        var tmp;
        if (false) {
          tmp = value;
        } else {
          tmp = THROW_CCE();
        }
        return this.h1t(encoder, tmp);
      }
      o1m(decoder) {
        throw SerializationException().h1o("'kotlin.Nothing' does not have instances");
      }
    }
    initMetadataForObject($, 'NothingSerializer', VOID, VOID, [KSerializer()]);
    NothingSerializerClass = $;
  }
  return NothingSerializerClass;
}
var NothingSerializer_instance;
function NothingSerializer_getInstance() {
  if (NothingSerializer_instance === VOID)
    new (NothingSerializer())();
  return NothingSerializer_instance;
}
var DurationSerializerClass;
function DurationSerializer() {
  if (DurationSerializerClass === VOID) {
    class $ {
      constructor() {
        DurationSerializer_instance = this;
        this.i1t_1 = new (PrimitiveSerialDescriptor())('kotlin.time.Duration', STRING_getInstance());
      }
      m1m() {
        return this.i1t_1;
      }
      j1t(encoder, value) {
        encoder.i1s(Duration__toIsoString_impl_9h6wsm(value));
      }
      n1m(encoder, value) {
        return this.j1t(encoder, value instanceof Duration() ? value.ai_1 : THROW_CCE());
      }
      k1t(decoder) {
        return Companion_getInstance_0().cr(decoder.y1q());
      }
      o1m(decoder) {
        return new (Duration())(this.k1t(decoder));
      }
    }
    initMetadataForObject($, 'DurationSerializer', VOID, VOID, [KSerializer()]);
    DurationSerializerClass = $;
  }
  return DurationSerializerClass;
}
var DurationSerializer_instance;
function DurationSerializer_getInstance() {
  if (DurationSerializer_instance === VOID)
    new (DurationSerializer())();
  return DurationSerializer_instance;
}
var UuidSerializerClass;
function UuidSerializer() {
  if (UuidSerializerClass === VOID) {
    class $ {
      constructor() {
        UuidSerializer_instance = this;
        this.l1t_1 = new (PrimitiveSerialDescriptor())('kotlin.uuid.Uuid', STRING_getInstance());
      }
      m1m() {
        return this.l1t_1;
      }
      m1t(encoder, value) {
        encoder.i1s(value.toString());
      }
      n1m(encoder, value) {
        return this.m1t(encoder, value instanceof Uuid() ? value : THROW_CCE());
      }
      o1m(decoder) {
        return Companion_getInstance_1().ht(decoder.y1q());
      }
    }
    initMetadataForObject($, 'UuidSerializer', VOID, VOID, [KSerializer()]);
    UuidSerializerClass = $;
  }
  return UuidSerializerClass;
}
var UuidSerializer_instance;
function UuidSerializer_getInstance() {
  if (UuidSerializer_instance === VOID)
    new (UuidSerializer())();
  return UuidSerializer_instance;
}
//region block: exports
export {
  DurationSerializer_getInstance as DurationSerializer_getInstancehro2chq1hsif,
  InstantSerializer_getInstance as InstantSerializer_getInstance1nnon3owoxtdq,
  NothingSerializer_getInstance as NothingSerializer_getInstance9dlyq3xgob9w,
  UuidSerializer_getInstance as UuidSerializer_getInstance9zsrcpe794us,
};
//endregion

//# sourceMappingURL=BuiltInSerializers.mjs.map
